// *************************** Import CSS *************************** //

import "./we-outside-popup-banner.css";

// *************************** Import Images *************************** //

import "/src/assets/banner-images/we-outside-flyer-2026.png"

export const homepageBanner = 1;

// *************************************************** Insert Banner **************************************************** //

class WeOutsidePopupBanner extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `

  <!-- *********************************** BEGIN: BANNER CODE ************************************** --> 

  <div class="container banner-container">

      <div class="row col-12 mx-auto">

      <flyer-popup></flyer-popup>


  <!-- BEGIN: Smaller-Devices Announcement Banner Row -->

      <div class="banner-smaller-devices text-center pb-3">

          <p class="col-12 banner-text text-white bold pt-2 pb-3 mb-0">

            JOIN US&#33;<br>
            &#8220;WE Outside&#8221; Festival<br>
            Free &bull; Food &bull; Fun<br>
            <span class="medium-screens">Sat. | June 6 | 4-8PM | Dixon Park</span>
            <span class="smallest-screens">Saturday, June 6</span>
            <span class="smallest-screens">4-8PM &bull; Dixon Park</span>
          
          </p>
        
          <a>
            <button type="button" id="flyerButtonSm" class="banner-button btn text-black btn-sm text-center mx-auto">SEE FLYER</button>
          </a>

      </div>

    <!-- END: Smaller-Devices Announcement Banner Row -->


    <!-- BEGIN: Larger-Devices Announcement Banner Row -->

      <div class="banner-large-devices">

        <div class="col-12 text-center pt-0">

          <p class="banner-text serif-heading text-white text-size-h2 bold pt-3 pb-3 mb-0">
                
            JOIN US&#33;
                
            &#8220;WE Outside&#8221; Festival &bull; Free &bull; Food &bull; Fun<br>

            Sat. June 6 | 4-8PM | Dixon Park &nbsp;
                
            <a>
              <button type="button" id="flyerButtonLg" class="banner-button btn text-black btn-sm text-center mx-auto">SEE FLYER</button>
            </a>
              
          </p>
            
        </div>

      </div>

    <!-- END: Larger-Devices Announcement Banner Row -->

      <div class="banner-flyer">
        <img src="we-outside-flyer-2026.png" id="flyerImgSm" class="home-flyer" height="150px" aria-hidden="true" />
      </div>

      <div class="banner-flyer">
        <img src="we-outside-flyer-2026.png" id="flyerImgLg" class="home-flyer" height="150px" aria-hidden="true" />
      </div>

      </div>

   </div>


<!-- *********************************** END: BANNER CODE ************************************** --> 

    `
  }
}


// *********************** Define 'extends HTMLElements' Above *********************** //

customElements.define('we-outside-popup-banner', WeOutsidePopupBanner);